import { withFormField } from "@swa-ui/form";

import { PassengerSelector } from "../../PassengerSelector";

/**
 * PassengerSelectorFormField provides support for a standard PassengerSelector
 * component to be used in a Form.
 */

export const PassengerSelectorFormField = withFormField(PassengerSelector, {
  shouldRegister: false,
});
